module.exports = __webpack_public_path__ + "images/newerp_button3.1790221230673.png";